module.exports = __webpack_public_path__ + "img/drh5_icon_x.daedee64.png";